<template>
  <b-row>
    <b-col sm="12" md="12" lg="12">
      <b-form-group label="DisplayName" label-for="DisplayName">
        <b-form-input
          type="text"
          id="DisplayName"
          placeholder="Informe o nome de exibição"
          v-model="model.displayName"
        />
        <span class="text-danger" v-if="modelstate['DisplayName']">
          {{ modelstate["DisplayName"][0] }}
        </span>
      </b-form-group>
    </b-col>

    <b-col sm="12" md="3" lg="3">
      <b-form-group label="FieldType" label-for="FieldType">
        <b-form-select
          id="FieldType"
          :options="optionsType"
          v-model="model.fieldType"
        />
        <span class="text-danger" v-if="modelstate['FieldType']">
          {{ modelstate["FieldType"][0] }}
        </span>
      </b-form-group>

    </b-col>
    <!-- <b-col sm="12" md="3" lg="3">
      <b-form-group label="DefaultValue" label-for="DefaultValue">
        <b-form-input
          type="text"
          id="DefaultValue"
          placeholder="Informe o valor padrão"
          v-model="model.defaultValue"
        />
        <span class="text-danger" v-if="modelstate['DefaultValue']">
          {{ modelstate["DefaultValue"][0] }}
        </span>
      </b-form-group>
    </b-col>
    <b-col sm="12" md="3" lg="3">
      <b-form-group label="DefaultGeraAnomalia" label-for="DefaultGeraAnomalia">
        <b-form-select
          id="DefaultGeraAnomalia"
          :options="optionsAnomaly"
          v-model="model.defaultGeraAnomalia"
        />
        <span class="text-danger" v-if="modelstate['DefaultGeraAnomalia']">
          {{ modelstate["DefaultGeraAnomalia"][0] }}
        </span>
      </b-form-group>

    </b-col>
    <b-col sm="12" md="3" lg="3">
      <b-form-group label="DefaultPermiteAnexo" label-for="DefaultPermiteAnexo">
        <b-form-select
          id="DefaultPermiteAnexo"
          :options="optionsBoolean"
          v-model="model.defaultPermiteAnexo"
        />
        <span class="text-danger" v-if="modelstate['DefaultPermiteAnexo']">
          {{ modelstate["DefaultPermiteAnexo"][0] }}
        </span>
      </b-form-group>

    </b-col> -->

    <b-col v-if="model.fieldType == 9000" sm="12" md="12" lg="12">
      <b-form-group label="ScriptPythonLoadData" label-for="ScriptPythonLoadData">
        <b-form-textarea
          id="ScriptPythonLoadData"
          v-model="model.scriptPythonLoadData"
          style="height: 10rem"
        />
        <span class="text-danger" v-if="modelstate['ScriptPythonLoadData']">
          {{ modelstate["ScriptPythonLoadData"][0] }}
        </span>
      </b-form-group>
    </b-col>
<!-- 
    <b-col sm="12" md="12" lg="12">
      <b-form-group label="ScriptPythonValidation" label-for="ScriptPythonValidation">
        <b-form-textarea
          id="ScriptPythonValidation"
          v-model="model.scriptPythonValidation"
          style="height: 10rem"
        />
        <span class="text-danger" v-if="modelstate['ScriptPythonValidation']">
          {{ modelstate["ScriptPythonValidation"][0] }}
        </span>
      </b-form-group>
    </b-col>

    <b-col sm="12" md="12" lg="12">
      <b-form-group label="ScriptPythonProcess" label-for="ScriptPythonProcess">
        <b-form-textarea
          id="ScriptPythonProcess"
          v-model="model.scriptPythonProcess"
          style="height: 10rem"
        />
        <span class="text-danger" v-if="modelstate['ScriptPythonProcess']">
          {{ modelstate["ScriptPythonProcess"][0] }}
        </span>
      </b-form-group>
    </b-col> -->

    <!-- {{ model }} -->
  </b-row>
</template>

<script>
// import AwesomeMask from "awesome-mask";

export default {
  name: "SystemIntegrationCrudData",
  props: {
    model: Object,
    modelstate: Object,
  },
  data() {
    return {
      optionsType: [
        { value: null, text: "Tipo" },
        // { value: 1, text: "Lógico" },
        // { value: 2, text: "Data" },
        // { value: 3, text: "Hora" },
        // { value: 4, text: "Decimal" },
        // { value: 5, text: "Inteiro" },
        // { value: 6, text: "Texto" },
        // { value: 7, text: "Lista" },
        // { value: 8, text: "Anotação" },
        { value: 9000, text: "Integração" },
      ],
      optionsBoolean: [
        { value: true, text: "Sim" },
        { value: false, text: "Não" },
      ],
      optionsAnomaly: [
        { value: 1, text: "Não" },
        { value: 2, text: "Sim" },
        // { value: 3, text: 'Por Script' },
      ],
    };
  },
  //   watch: {
  //     model() {
  //       this.loadTableRows();
  //     }
  //   },
  //   directives: {
  //     mask: AwesomeMask,
  //   },
};
</script>
